export default __webpack_public_path__ + "static/media/number3.12f0bb6b.svg";